<div class="page-content bg-light">
    <div class="dz-bnr-inr bg-secondary dz-bnr-inr-md"
        style="background-image:url(https://ezhuthupizhai.in/wp-content/uploads/2024/03/Banner_3-scaled-1.jpg);">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="dz-bnr-inr-entry text-start">
                        <h1 class="text-white">Shipping & Delivery Policy</h1>
                        <nav aria-label="breadcrumb" class="breadcrumb-row">
                            <ul class="breadcrumb text-white">
                                <li class="breadcrumb-item"><a href="/home" class="text-white">Home</a></li>
                                <li class="breadcrumb-item text-white">Shipping & Delivery Policy</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="content-inner">
        <div class="container">
            <div class="row about-style2 align-items-xl-center align-items-start">

                <h2 class="fs-4 mb-2">Overview</h2>
                <p>This Shipping & Delivery Policy outlines the details of how your orders are processed, shipped, and delivered by Ezhuthupizhai. We aim to ensure a smooth and efficient delivery experience for all our customers.</p>

                <h2 class="fs-4 mb-2">Order Processing Time</h2>
                <p>All orders are processed within <strong>1-3 business days</strong> (excluding weekends and holidays) after receiving your order confirmation email. You will receive another notification when your order has shipped.</p>
                <p>Please note that processing times may be extended during peak seasons or promotional periods.</p>

                <h2 class="fs-4 mb-2">Shipping Rates & Delivery Estimates</h2>
                <p>Shipping charges for your order will be calculated and displayed at checkout. We offer various shipping options to meet your needs.</p>

                <h3 class="fs-4 mb-2">Domestic Shipping (Within India)</h3>
                <p>We partner with reliable courier services to ensure timely delivery across India.</p>
                <ul class="mb-3 ms-3">
                    <li><strong>Standard Shipping:</strong> Estimated delivery within 5-7 business days after dispatch.</li>
                    <li><strong>Express Shipping (if available):</strong> Estimated delivery within 2-3 business days after dispatch.</li>
                </ul>
                <p>Delivery delays can occasionally occur due to unforeseen circumstances or remote locations.</p>

                <h3 class="fs-4 mb-2">International Shipping (if applicable)</h3>
                <p>At this time, we do not offer international shipping. Please check back later for updates.</p>
                <h2 class="fs-4 mb-2">Order Tracking</h2>
                <p>Once your order has shipped, you will receive an email notification from us which will include a tracking number you can use to check its status. Please allow 24-48 hours for the tracking information to become available.</p>
                <p>You can track your order directly on the courier partner's website using the provided tracking number, or through our <a href="/track-order">Track Order</a> page.</p>

                <h2 class="fs-4 mb-2">Shipping Address & Incorrect Details</h2>
                <p>Please ensure your shipping address is accurate and complete during checkout. We are not responsible for orders shipped to incorrectly provided addresses.</p>
                <p>If you realize you have provided an incorrect address, please contact us immediately at <a href="mailto:{{email}}">{{email}}</a>. While we will do our best to assist, we cannot guarantee changes if the order has already been processed or shipped.</p>

                <h2 class="fs-4 mb-2">Damaged or Lost Packages</h2>
                <p>If your order arrives damaged, please contact us immediately at <a href="mailto:{{email}}">{{email}}</a> with photos of the damaged packaging and product(s). We will work with the shipping carrier to resolve the issue and arrange for a replacement or refund, as appropriate.</p>
                <p>If your package is lost in transit (tracking shows no updates for an extended period, or it's confirmed lost by the carrier), please contact us. We will initiate an investigation with the shipping carrier and work towards a resolution, which may include a replacement or refund.</p>

                <h2 class="fs-4 mb-2">Undeliverable Packages</h2>
                <p>If a package is returned to us as undeliverable due to reasons such as incorrect address, multiple failed delivery attempts, or refusal by the recipient, we will contact you to arrange re-delivery. Additional shipping charges may apply for re-delivery.</p>

                <h2 class="fs-4 mb-2">Contact Us</h2>
                <p>If you have any questions or concerns regarding your order's shipping and delivery, please do not hesitate to contact us at <a href="mailto:{{email}}">{{email}}</a>. We are here to help!</p>

            </div>
        </div>
    </section>
</div>